// extracted by mini-css-extract-plugin
module.exports = {"main":"Account_main__2waVn","content":"Account_content__hVni_"};